import React from 'react'
import Typography from '../../../../global/typography'

//* utils
import { ModuleNames } from '../../../../../constants/componentNames.constants'
import { MicrocopySet } from '../../../../../models/others/microcopy'
import { getMicrocopyWithoutNumber } from '../../../../../utils/microcopy.utils'

export const setMetaFields = (microcopy: MicrocopySet, metaInformation: any) => {
  if (!Array.isArray(metaInformation)) return {}
  let customerLogoSrc = ''
  let customerLogoAlt = ''

  const eyebrows: any = metaInformation.map((topic: any, i: number) => {
    const topicData: any = {
      type: topic.__typename,
      microcopyType: '',
      eyebrowText: [],
      eyebrowValue: topic.title,
    }

    if (topicData.type === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
      topicData.microcopyType = 'client'
      topicData.eyebrowValue = topic.customerName
      customerLogoAlt = topic.colorLogo?.altText || 'UiPath Customer Logo'

      if (topic.colorLogo?.image?.file?.url) {
        customerLogoSrc = topic.colorLogo.image.file.url
      }
    }

    if (topicData.type === ModuleNames.TOPIC_REGION) topicData.microcopyType = 'region'
    if (topicData.type === ModuleNames.TOPIC_INDUSTRY) topicData.microcopyType = 'industry'

    if (topicData.microcopyType) {
      topicData.eyebrowText = getMicrocopyWithoutNumber(
        microcopy,
        topicData.microcopyType,
        'eyebrowText'
      )
    }

    return (
      <Typography type="labelAlt" className="Hero__Text-Meta-Item" key={`${topicData.type}--${i}`}>
        {topicData.eyebrowText[0]?.value && (
          <span className="Hero__Eyebrow-Grey">{topicData.eyebrowText[0]?.value}</span>
        )}

        {topicData.eyebrowValue}
      </Typography>
    )
  })

  return { eyebrows, customerLogoSrc, customerLogoAlt }
}
